import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showSaveSearch } from '../actions';

const DuplicateSearchAction = ({
  code,
  category,
  readStatus,
  readErrors,
  duplicateSearch,
}) => (
  <RibbonMenu
    name="duplicate"
    icon="clone"
    message="actions.duplicate"
    onClick={() => duplicateSearch(category, code)}
    className="aridhia-duplicate-search-action"
    disabled={readStatus !== states.SUCCESS || firstError(readErrors) !== null}
  />
);

const mapStateToProps = ({
  search: { searches },
}, { category, code }) => {
  const search = findResult(searches, category, code);

  return {
    readErrors: search ? search.readErrors : [],
    readStatus: search ? search.readStatus : states.NONE,
  };
};

const mapDispatchToProps = {
  duplicateSearch: (category, code) => showSaveSearch(category, code, true),
};

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateSearchAction);
